import { createSelector } from 'reselect';

import { BrandState } from 'store/widgets/TradeInNewCalculator/brand/index';
import { convertListToObjectBy } from 'utils/fn';

import { selectTradeInNewWidgetCalculator } from '../common/selectors';

export const selectTradeInBrand = (state): BrandState =>
  selectTradeInNewWidgetCalculator(state).brand;

export const selectTradeInBrandTitle = (state) =>
  selectTradeInBrand(state).title;

export const selectTradeInBrandSlug = (state) =>
  selectTradeInBrand(state).slug;

export const selectTradeInBrandSelectedValue = (state) =>
  selectTradeInBrand(state).selectedValue;

export const selectTradeInBrandIsValid = (state) =>
  selectTradeInBrand(state).isValid;

export const selectTradeInBrandListForSelect = createSelector(
  selectTradeInBrand,
  (items) => items.data.map(brand => ({
    slug: brand,
    label: brand,
  })),
);

export const selectTradeInBrandBySlug = createSelector(
  selectTradeInBrandListForSelect,
  convertListToObjectBy('slug'),
);

export const selectTradeInBrandIsDisabled = (state) =>
  !selectTradeInBrandListForSelect(state).length;

export const selectTradeInBrandIsError = (state) =>
  !selectTradeInBrandIsValid(state) && !selectTradeInBrandIsDisabled(state);
